export default __webpack_public_path__ + "static/media/descricao3.bba4a0d1.png";